import { SxProps, Theme } from "@mui/material";

export const tableContainerSx: SxProps<Theme> = {
  height: "calc(90vh - 220px)",
  minHeight: 400,
  typography: "body1",
};

export const tableDescriptionStyle: React.CSSProperties = {
  padding: "12px 16px",
  borderBottom: "1px solid #eee",
  marginTop: "-22px",
  fontSize: "13px",
};

export const alertSx: SxProps<Theme> = {
  mb: 1,
  fontSize: "12px",
};

export const bulkBarSx: SxProps<Theme> = {
  display: "flex",
  alignItems: "center",
  gap: 2,
  px: 2,
  py: 1,
  mb: 1,
  backgroundColor: "#e3f2fd",
  borderRadius: 1,
  border: "1px solid #90caf9",
  height: 35,
  fontSize: "12px",
};

export const bulkBarLabelStyle: React.CSSProperties = {
  fontWeight: 500,
};

export const bulkBarButtonSx: SxProps<Theme> = {
  textTransform: "none",
  fontSize: "11px",
  py: "2px",
  px: "10px",
  minHeight: 0,
};
